import { createAsyncThunk } from '@reduxjs/toolkit';
import { logger } from 'common/services';
import { tagServiceApi } from 'tags/tagServiceApi';

import { EventWizardFormSerializedValues } from '../../validation';

export const updateTagCategories = createAsyncThunk<void, { eventId: number; values: EventWizardFormSerializedValues }>(
  '[Event Wizard] Update Tag Categories',
  async ({ eventId, values }, { dispatch }) => {
    const tagCategories = values.tagCategories ?? [];

    try {
      const categories = tagCategories.map(({ name, tags }) => ({ name, tags, isSingleSelection: true }));
      await dispatch(tagServiceApi.endpoints.setEventTagCategories.initiate({ eventId, categories })).unwrap();
    } catch (error) {
      logger.error('Failed to save tag categories for event', { eventId, error });
    }
  }
);
